var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.dataHasLoaded)?_c('div',{staticClass:"issue-edit-form justify-center"},[(_setup.refetchReady)?_c(_setup.handleForm,{attrs:{"parentData":_setup.handleFormParentData},on:{"close-form":_setup.closeForm}}):_vm._e(),(!_setup.refetchReady)?_c('div',{staticClass:"new-edit-form"}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }